const svgIcons = {
  dashboard: "DASHBOARD_ICON-BLUE",
  timesheets: "TIMESHEETS ICON - BLUE",
  help_center: "GENERAL_SUPPORT_ICON-BLUE",
  profile: "profile_icon",
  edit: "EDIT_ICON",
  personal_details: "PERSONAL_DETAILS_ICON-BLUE",
  signOut: "sign-out-alt-solid",
  settings: "SETTINGS",
  user_password: "USER_PASSWORD_ICON",
  SECURITY_ICON_BLUE: "SECURITY_ICON-BLUE",
  scope: "SCOPE",
  security: "SECURITY_ICON-BLUE",
  arrow_right: "NAV-ARROW-RIGHT",
  maintenance: "TECHNICAL_SUPPORT_ICON-BLUE",
  exclamation: "EXCLAMATION_TRIANGLE_BLUE",
  logs: "fichier-texte",
  jobs_logs: "EMAIL_SEND",
  policies: "POLICY",
  share: "SHARE_ICON_BLUE",
  webServices: "WEB_SERVICES_BLUE",
  at: "AT_BLUE_SECONDARY",
  envelope_open_text: "ENVELOPE_OPEN_TEXT_BLUE",
  plane_paper: "PLANE_PAPER_BLUE",
  wifi: "WIFI_BLUE",
  wifi_sky_blue: "WIFI_SKY_BLUE",
  privacy: "PRIVACY",
  terms: "TERMS-AND-CONDITIONS",
  clock_checked: "TIMESHEET_ISSUES_ICON_GRAY",
  clock_checked_success: "TIMESHEET_ISSUES_ICON_SUCCESS",
  clock_checked_danger: "TIMESHEET_ISSUES_ICON_DANGER",
  filter_icon: "FILTER_ICON",
  sort_num_up: "SORT_NUMERIC_UP",
  sort_num_down: "SORT_NUMERIC_DOWN",
  chat: "CHAT",
  chat_dots: "CHAT_DOTS",
  history: "HISTORY",
  lock: "LOCK",
  sms_logs: "SMS",
  excel: "EXCEL",
  timesheet_config_page: "CALENDAR ICON - BLUE",
  microsoft_small: "ms-sign-in-small",
  microsoft_big: "ms-sign-in-big",
  config_cron: "SETTINGS",
  get_alert: "GET_ALERT",
  message_sent: "MESSAGE_SENT",
  invoices: "PAYMENTS_ICON",
  invoices_email_templates: "INVOICES_EMAIL_TEMPLATES",
  timesheets_email_templates: "TIMESHEETS_EMAIL_TEMPLATES",
  job: "JOBS_ICON-BLUE",
  vendor: "VENDOR_ICON"
}

export default svgIcons;
